<template>
  <div class="min-h-50 text-NotoSansLight max-w-6xl mx-auto px-4 py-4" :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <Breadcrumb class="md:hidden" :title="'每日一句'" />
    <div class="title mb-8">
      <h3 class="text-xl textColorRed text-center border borderRed py-1 block text-NotoSansRegular">每日一句</h3>
    </div>
    <div v-if="dailyData">
      <div class="content xl:px-0 mb-10">
        <div class="flex flex-wrap md:justify-between">
              <div class="flex">
                  <div class="flex items-center justify-between max-w-2xl px-4 py-3 mx-auto border cursor-pointer rounded dark:border-gray-700" :class="{ 'border-blue-500': isShowEn }" @click="isShowEn = !isShowEn">
                      <div class="flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-gray-400 sm:h-9 sm:w-9" viewBox="0 0 20 20" fill="currentColor" v-if="!isShowEn">
                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                        </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-blue-600 sm:h-9 sm:w-9" viewBox="0 0 20 20" fill="currentColor" v-if="isShowEn">
                              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                          </svg>
                        <div class="flex flex-col items-center mx-1 space-y-1">
                          <h2 class="text-sm font-medium text-gray-700 dark:text-gray-200">English</h2>
                        </div>
                      </div>
                  </div>
                  <div class="flex items-center justify-between max-w-2xl px-4 py-3 mx-auto border cursor-pointer rounded dark:border-gray-700 ml-2" :class="{ 'border-blue-500': isShowJp }" @click="isShowJp = !isShowJp">
                      <div class="flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-gray-400 sm:h-9 sm:w-9" viewBox="0 0 20 20" fill="currentColor" v-if="!isShowJp">
                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                        </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-blue-600 sm:h-9 sm:w-9" viewBox="0 0 20 20" fill="currentColor" v-if="isShowJp">
                              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                          </svg>
                        <div class="flex flex-col items-center mx-1 space-y-1">
                          <h2 class="text-sm font-medium text-gray-700 dark:text-gray-200">日本語</h2>
                        </div>
                      </div>
                  </div>
                  <!-- <div class="flex items-center justify-between max-w-2xl px-8 py-4 mx-auto border border-blue-500 cursor-pointer rounded-xl" @click="isShowJp = !isShowJp">
                      <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-blue-600 sm:h-9 sm:w-9" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                          </svg>

                          <div class="flex flex-col items-center mx-5 space-y-1">
                              <h2 class="text-base font-medium text-gray-700 dark:text-gray-200">Popular</h2>
                          </div>
                      </div>
                  </div> -->
              </div>
          <!-- <div class="flex text-sm w-full md:w-auto order-2 md:order-1">
            <a class="px-3 py-2 border cursor-pointer langBtn borderColordarkgray mr-2" :class="{ 'bgLiveBlack text-white': isShowEn }" @click="isShowEn = !isShowEn">英文</a>
            <a class="px-3 py-2 border cursor-pointer langBtn borderColordarkgray" :class="{ 'bgLiveBlack text-white': isShowJp }" @click="isShowJp = !isShowJp">日文</a>
          </div> -->
          <div class="search flex flex-col md:flex-row md:items-center w-full md:w-auto order-1 md:order-2 mb-3 md:mb-0">
            <label for="search" class="mr-1 mb-2 md:mb-0 text-md">關鍵字搜尋</label>
            <input v-on:keyup.13="search" autocomplete="off" v-model="searchVal" type="text" class="cursor-text py-1 focus:outline-none border px-2 mb-2 md:mb-0 border-gray-400" placeholder="Search..." name="search">
            <a class="button-search px-4 py-1 md:ml-2 border cursor-pointer text-md text-center" @click="search">送出</a>
          </div>
        </div>

        <div class="list mt-6 w-full">
          <div v-for="(item, index) in dailyData" :key="index">
            <div class="border border-b-0 px-4 py-4 border-gray-600">{{ moment(item.publish_at).format('YYYY/MM/DD') }}</div>

            <div class="border border-gray-600 px-4 py-4">
              <DailyChild :data="item" :isShowEn="isShowEn" :isShowJp="isShowJp" />
            </div>
          </div>
          <!-- <table class="rwd-table w-full mb-2">
            <tbody>
              <tr v-for="(item, index) in dailyData" :key="index">
                <td class="border px-4 py-4 border-gray-600 lg:border-r-0">{{ moment(item.publish_at).format('YYYY/MM/DD') }}</td>
                <td class="border border-gray-600">
                  <div class="px-4 py-4">
                    <DailyChild :data="item" :isShowEn="isShowEn" :isShowJp="isShowJp" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table> -->

        </div>
      </div>

        <PaginateComponent :pagination="pagination" v-on:pageChangeHandler="pageChangeHandler" />

    </div>
    <img src="~@/assets/icon/Pulse.gif" class="h-12 mt-12 mx-auto" v-else>
  </div>
</template>
<script>
import axios from 'axios'
import PaginateComponent from '@/components/modules/Paginatation'
import Breadcrumb from '@/components/modules/Breadcrumb'
import Bus from '@/components/modules/bus.js'
import DailyChild from '@/components/company/DailySentence_child'
export default {
  name: 'DailySentence',
  data () {
    return {
      dailyData: null,

      searchVal: null,

      isPlaying: false,
      playIdx: null,

      // pagination
      pageSize: 5,
      pagination: {
        currentPage: 1,
        length: 5
      },

      isShowEn: true,
      isShowJp: true,

      showDictIdx: -1
    }
  },
  components: {
    PaginateComponent,
    Breadcrumb,
    DailyChild
  },
  mixins: [
  ],
  computed: {
  },
  mounted () {
    this.getData()
  },
  updated () {
  },
  methods: {
    getData () {
      let self = this
      let dataObj = {
        params: {}
      }
      if (self.searchVal) {
        dataObj.params.query = self.searchVal
      }
      axios.get(`/daily-sentences?page=${self.pagination.currentPage}&pageSize=${self.pageSize}`, dataObj)
        .then((response) => {
          self.pagination.length = response.data.last_page
          self.dailyData = response.data.data
        })
    },
    async search () {
      let self = this
      await self.getData()

      self.pageChangeHandler()

      self.playIdx = null
      // self.pauseAudio()
    },
    async pageChangeHandler (pageChangeHandler) {
      let self = this
      self.pagination.currentPage = pageChangeHandler
      self.productData = null

      self.$nextTick(() => {
        self.getData()
      })
    },
    openDailySentence (item) {
      Bus.$emit('openDailySentence', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.langBtn {
  color: #434343;
}
.title {
  width: 6.5rem;
}
.button-search {
  background-color: white;
  border-color: #cbd5e0;
  color: #434343;
  transition: 0.3s;
  &:hover {
    background-color: #434343;
    border-color: white;
    color: white;
  }
  &:focus {
    outline: none !important;
  }
}
.rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: separate;
  border-spacing: 0 1rem;
  color: #333;
  // overflow: hidden;
  tr {
    // text-align: center;
    &:first-child {
      border-top: none;
    }
    th {
      display: none;
      font-size: 0.8rem;
      color: #808080;
    }
  }
  td {
    // text-align: center;
    display: block;
    background: white;
    // &:before {
    //   content: attr(data-th) ": ";
    //   font-weight: bold;
    //   width: 120px;
    //   display: inline-block;
    //   color: #000;
    // }
  }
}

@media screen and (max-width: 1025px) {
  // .rwd-table { border-spacing: 0 0rem !important; }
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-table th,
  .rwd-table td {
    text-align: left;
  }
  .rwd-table th,
  .rwd-table td {
    padding: .5em 1em;
  }

}
@media screen and (min-width: 1024px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell !important;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table td {
    padding: .5em !important;
  }
}
</style>
